import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { http, API } from "../store/API";
var _ = require("lodash");
import Invoices from "./modules/invoices";

Vue.use(Vuex);

const defaultState = () => {
    return {
        forms: {
            form1: {
                init1: true,
                init2: true,
            },
        },
        total_due_amount_invoices: 0,
        user_name: null,
        user: {
            username: "",
            password: "",
            token: "",
            authorized: false,
            is_updated: false,
            mobile_verified: false,
            email_verified: false,
        },
        packages_list: [],
        content_list: [],
        userShipments: [],
        userData: {},
        addressBook: [],
        countries: [],
        rate: [
            //     {
            //     charge: 4110.18,
            //     currency: "SAR",
            //     cutOfTime: "2020-10-13T21:45:00",
            //     delivery: "2020-10-14",
            //     id: "b49a3dcc86",
            //     rate_response: "eyJpdiI6ImZ3UXJQdk1RVThvbjk5WE90NEpqM3c9PSIsInZhbHVlIjoiRTFSNkFFSmJpQmhkZ2hObzgyRGpwTHgzQkFKWEYyeVdsOXU1YUdPVVR0eEZ2czk0ZU9ZUTNGYVJHRVpEeFJBS1NxWkJcL1FIeTg4K1QrQ01vdDBLb3BxR0kyUFRsNzIrOGlNekFRVzNETVNUa244ckJEY0lqSVwvUkcyQ3lqak80NXUwd3VieEc5TGxPWEg1VStudUJcL1VZbFdadU8rWU9SQ3ZJYWxjSlpHOFdGb1I5TldpSGM1VHJmY0NMR3BHSmxMUElCU2JWZXBcL25QZlJQbXVwbmlxTFwvXC94WFRCZTRMaTBjMmNPWkMxQmtKVmtnODdMVFwvUTJWN3lJaXN2b3NLdTVTVVFyYmZEc3J0eEJJVkZnYUpaRGhJTVNxT3pNZTlpbVFLQW1aQTdGdXVZTXBBMzNhbkdzdFI3OW12VTB3NXVNWmZ1VVwvWmpnbld6UXB4aXpENzBoVFFnQ1ZpckFQVThhY1JaS0ltK09MWmJTK3ZHK0FjbXBxKzNaVzV2Z2RCZEtkRm5LWXJRRFFsenNudmpsQnpsM0MwRmpZM2g1N2xCN3UwNmlvaFlEYjdkNXA2WGxUR0srb3o2NlQzWFJNb0lZZ3o3b3NleE1EaXNzNG9ybVhHangxVXVSXC9MekYxRkpqMThPbDVwUXJXeFhUcFFRXC9lZHFxajg1YTBHd3E5NnZmaDRvSjBcL3o5UEpIc20wYVwvYmxBTWpablNiUDltTTNvektpbGg1UzBvcFA1NXJLalF0b0Y1WVRIY3JUcm9lXC91V1wvXC9MaHMreDF5R1lpOUY0dnZ6b0NhZ1FLXC9xaTZPTlFrejdxTXRFY1lIQUxkOHhTdDBKSlM3ZzNjcFhEUlNSd0MyTktId0JVeEZyamYzQlk2UU5SZm01VGRSdTk2N0xQWE9FdVY4MnBXZVFEOFRrNVdLK2phd3gzVnlUZ0hMSE5IUEtGZWJsVUZwZGY0a2Zjb3ZNanVhUjNnWmVWcGUzYU9cL2d1b0NUcEpjOG5ldVg3aVRncTFxTmVodXZpQ1hHbHNzY0ZSc3FSV3FLb0JtOHJJZDQ3ZnJlNkoyWFIxMFwvWjVUYW40bzZwaENTdHpKTWVQdzlkbGJZYXNob1wvSUZMcUxURWFNcnU1ZExDVXVIU1NoM2EyQUNhN25cLzJZa21YZm1aQzlTNFBrSEt4UUdiS2pWQTVRU0ltTEZiU25lQ25HZGE5YXZKVEN1c0dabkdQSXJhTkx2ZVYyd1ZVbms2QWlvd0pzSGdHWld0MmdlMEdhdFE1ZDdyU3VkVEZhRmFUc2FZa2NYUUthUHZSOUxCSFBGRXk1SGVJU3R0b0NtU21mK3krcVVnUGVVNEFZRTh5aHBKM1pEMVZSdGlpbVllOW91IiwibWFjIjoiYWM2YzliZjI4YjBlMDlhZWEzZDYwNzQ3ZDIwNTU5Yjg4Nzg5YjAxYjc2ZGIyYTNkZTQ0MzE1ZGJhMDU1Njc4OCJ9",
            //     reference: "eyJpdiI6IkE1MXNaN0ZpeXQxUHNmOWRic09kbVE9PSIsInZhbHVlIjoia0V6cHlIdGpoaldkbW9PZldlUk4zbUROOFJzbWNQbWR1MWp0SkFEQTdZaz0iLCJtYWMiOiJlNGZmNzczNmI3ZTFiMTkyYjI0OTNlMmViZmY4Y2QwYTVmOTc2ODZlMmIwOGJjZGNhODk0MzQyYzA4NGU3N2M5In0=",
            //     save_amount: 11179.676,
            //     service_name: "EXPRESS DOMESTIC",
            //     service_type: "N",
            //     shipment_date: "2020-10-13",
            //     total_weight: 10,
            //     vendor: "DHL"
            // }
        ],
        service: null,
        filterdService: {},
        shipment: {
            shipment_id: null,
            hash: null,
            sendTo: {
                street: "",
                city: "",
                state: "",
                country: "",
                zip: "",
                email: "",
                phone: "",
                id: -1,
            },
            sendFrom: {
                street: "",
                city: "",
                state: "",
                country: "",
                zip: "",
                email: "",
                phone: "",
                id: -1,
            },
            packageSet: [],
            packages: [],
            packageUnit: "metric",
            items: [],
            insured: 0,
            reason: null,
            customer_reference: null,
            user_identity: null,
            total_weight: 0,
        },
        fees: null,
        contents: [],
        extra_charges: {
            usd: {
                insurance: 25,
                shipping: 78,
            },
        },
        citiesSearchResults: [],
        postalCodeListResults: [],
        statesSearchResult: [],
        districtsSearchResult: [],
        currentOrderDetails: null,
        postCodeSearchResult: null,
        postCodeSearchResultByKeyword: [],
        viewsForForm2: null,
        lastShipment: null,
        domestic_rate: false,
        transactions: [],
        statistics: null,
        banks: [],
        credit_transactions: [],
        lastPaymentOption: true,
        lastInvoice: null,
    };
};

export default new Vuex.Store({
    modules: {
        Invoices,
    },
    // Strict mode will be only for development, please turn this off on production
    strict: process.env.NODE_ENV !== "production",
    plugins: [createPersistedState()],
    ///////
    state: defaultState(),
    getters: {
        user_name({ user_name }) {
            return user_name;
        },
        getStatistics({ statistics }) {
            return statistics;
        },
        addressBook({ addressBook }) {
            return addressBook;
        },
        packages_list({ packages_list }) {
            return packages_list;
        },
        content_list({ content_list }) {
            return content_list;
        },
        shipment_id({ shipment }) {
            return shipment.shipment_id;
        },
        getReason({ shipment }) {
            return shipment.reason;
        },
        shipping({ shipment }) {
            return shipment.packages;
        },
        getCurrentOrderDetails({ currentOrderDetails }) {
            return currentOrderDetails;
        },
        getTransactions({ transactions }) {
            return transactions;
        },
        getDomesticRate({ domestic_rate }) {
            return domestic_rate;
        },
        getInsurance({ shipment }) {
            return shipment.insured;
        },
        shipment({ shipment }) {
            return shipment;
        },
        getFees({ fees }) {
            return fees;
        },
        userData(state) {
            return state.userData;
        },
        contents(state) {
            return state.contents;
        },
        getViewsForForm2(state) {
            return state.viewsForForm2;
        },
        getRates: (state) => {
            let s = [];
            state.rate.forEach((r, i) => {
                s.push({
                    currency: r.currency,
                    price: r.charge,
                    savings: r.save_amount,
                    serviceType: r.service_name,
                    provider: r.vendor,
                    weight: r.total_weight,
                    delivery: r.delivery,
                    id: r.id,
                });
            });
            return s;
        },
        totalWeight: (state) => {
            let total = 0;
            state.shipment.packages.forEach((p) => {
                if (p.measurement != "metric") {
                    let b = p.weight * p.quantity;
                    let c =
                        ((p.length * p.width * p.height) / 139) * p.quantity;
                    let a = b > c ? b : c;
                    total += a * 0.453592;
                } else {
                    let b = p.weight * p.quantity;
                    let c =
                        ((p.length * p.width * p.height) / 5000) * p.quantity;
                    let a = b > c ? b : c;
                    total += a;
                }
            });
            return total;
        },
        getCharges: (state) => {
            if (state.shipment.insured) {
                return [
                    {
                        category: "insurance",
                        price: state.extra_charges.usd.insurance,
                    },
                    {
                        category: "shipping cost",
                        price: state.extra_charges.usd.shipping,
                    },
                ];
            } else {
                return [
                    {
                        category: "shipping cost",
                        price: state.extra_charges.usd.shipping,
                    },
                ];
            }
        },
        getService(state) {
            return state.service;
        },
        getPhoneNumber(state) {
            return state.userData.mobile;
        },
    },

    //******************
    //* Mutations
    //******************
    mutations: {
        updateEmailVerification(state) {
            state.user.email_verified = true;
            state.userData.email_verified = true;
        },
        verify_mobile(state) {
            state.user.mobile_verified = true;
            state.userData.mobile_verified = true;
        },
        save_all_transactions(state, payload) {
            state.transactions = payload;
        },
        saveLastShipment(state, payload) {
            state.lastShipment = payload;
        },
        editViewsForForm2(state, type) {
            state.viewsForForm2 = type;
        },
        init1: (state) => {
            state.forms.form1.init1 = false;
        },
        init2: (state) => {
            state.forms.form1.init2 = false;
        },
        reset: (state) => {
            Object.assign(state, defaultState());
        },

        resetSession: (state) => {
            let user = state.user;
            let d = state.userData;
            Object.assign(state, defaultState());
            state.user = user;
            state.userData = d;
        },

        userData: (state, payload) => {
            state.userData = payload;
            state.user.email_verified = payload.email_verified;
            state.user.mobile_verified = payload.mobile_verified;
            state.user.is_updated = payload.is_updated;
        },

        userShipment: (state, payload) => {
            state.userShipments = payload;
        },

        saveUserData: (state, payload) => {
            state.user = payload;
        },

        countries: (state, payload) => {
            state.countries = payload;
        },

        address: (state, payload) => {
            state.addressBook = payload;
        },

        sendTo: ({ shipment }, payload) => {
            shipment.sendTo = payload;
        },

        sendFrom: ({ shipment }, payload) => {
            shipment.sendFrom = payload;
        },

        rate: (state, payload) => {
            state.rate = payload.map((p) => ({
                ...p,
                id: Math.random().toString(16).slice(2),
            }));
        },

        finalWeight: (state, payload) => {
            state.shipment.total_weight = payload;
        },

        packages: ({ shipment }, payload) => {
            shipment.packages = payload;
        },

        packageSet: ({ shipment }, payload) => {
            shipment.packageSet = payload;
        },

        setPackageUnit: ({ shipment }, payload) => {
            shipment.packageUnit = payload;
        },

        addShipment: ({ shipment }, payload) => {
            var x = shipment.packages.length;
            shipment.packages.push({
                id: x,
                measurement: "metric",
                type: payload,
                weight: 0,
                length: 0,
                width: 0,
                height: 0,
                quantity: 1,
            });
        },
        addShipmentItem: ({ shipment }, payload) => {
            var x = shipment.packages.length;
            shipment.packages.push({
                id: x,
                measurement: payload.unit_system,
                type: payload.title.split(" ")[0],
                width: payload.width,
                length: payload.length,
                height: payload.height,
                weight: payload.weight,
                unit_system: payload.unit_system,
                quantity: 1,
            });
        },
        deleteShipment: ({ shipment }, payload) => {
            shipment.packages.splice(payload, 1);
            let x = 0;
            shipment.packages.forEach((s) => {
                s.id = x;
                x += 1;
            });
        },
        editQuantity: ({ shipment }, { id, quantity }) => {
            shipment.packages[id].quantity = quantity;
        },
        editWeight: ({ shipment }, { id, v }) => {
            shipment.packages[id].weight = v;
        },
        editLength: ({ shipment }, { id, v }) => {
            shipment.packages[id].length = v;
        },
        editWidth: ({ shipment }, { id, v }) => {
            shipment.packages[id].width = v;
        },
        editHeight: ({ shipment }, { id, v }) => {
            shipment.packages[id].height = v;
        },
        editTotalWeight: ({ shipment }, { id, total }) => {
            shipment.packages[id].total_weight = total;
        },

        service: (state, payload) => {
            state.service = payload;
            state.filterdService = state.rate.filter(
                (item) => item.id == payload.id
            )[0];
        },

        resetPackages: (state) => {
            state.shipment.packages = [];
            state.viewsForForm2 = null;
        },
        addItems: ({ shipment }, payload) => {
            shipment.items.push(payload);
        },

        eraseItems: ({ shipment }, payload) => {
            shipment.items.splice(payload, 1);
            let x = 0;
            shipment.items.forEach((d) => {
                d.id = x;
                x += 1;
            });
        },

        insured: ({ shipment }, payload) => {
            shipment.insured = payload;
        },

        contents: (state, payload) => {
            state.contents = payload;
        },
        reason: (state, payload) => {
            state.shipment.reason = payload;
        },
        customer_reference: (state, payload) => {
            state.shipment.customer_reference = payload;
        },
        user_identity: (state, payload) => {
            state.shipment.user_identity = payload;
        },
        save_fees: (state, payload) => {
            state.fees = payload;
        },

        verified: (state) => {
            state.user.verified = true;
        },

        citiesSearchResults: (state, payload) => {
            state.citiesSearchResults = payload;
        },

        postalCodeListResults: (state, payload) => {
            state.postalCodeListResults = payload;
        },

        statesSearchResult: (state, payload) => {
            state.statesSearchResult = payload;
        },

        currentOrderDetails: (state, payload) => {
            state.currentOrderDetails = payload;
        },

        postCodeSearchResult: (state, payload) => {
            state.postCodeSearchResult = payload;
        },

        postCodeSearchResultByKeyword: (state, payload) => {
            state.postCodeSearchResultByKeyword = payload;
        },
        domestic_rate: (state, payload) => {
            state.domestic_rate = payload;
        },
        save_list: (state, payload) => {
            state.packages_list = null;
            state.packages_list = payload;
        },
        save_content_list: (state, payload) => {
            state.content_list = payload;
        },
        restore_shipment(state, payload) {
            state.shipment.shipment_id = payload.id;
            state.shipment.hash = payload.hash;
            state.shipment.sendFrom = state.addressBook.filter(
                (address) => address.id == payload.origin.id
            )[0];
            state.shipment.sendFrom["phone"] = payload.origin.mobile;
            state.shipment.sendFrom["street"] = payload.origin.address_one;
            state.shipment.sendFrom["zip"] = payload.origin.postal_code;
            state.shipment.sendFrom["country"] =
                payload.origin.country.nice_name;

            state.shipment.sendTo = state.addressBook.filter(
                (address) => address.id == payload.destination.id
            )[0];
            state.shipment.sendTo["phone"] = payload.destination.mobile;
            state.shipment.sendTo["street"] = payload.destination.address_one;
            state.shipment.sendTo["zip"] = payload.destination.postal_code;
            state.shipment.sendTo["country"] =
                payload.destination.country.nice_name;

            let shipmentPackages = payload.packages.map((p, i) => ({
                ...p,
                id: i,
                measurement: p.unit_system == "SI" ? "metric" : "imperial",
                type: "parcel",
            }));
            state.shipment.packageSet = shipmentPackages;
            state.shipment.packages = shipmentPackages;

            state.contents = payload.contents.map((c) => {
                return {
                    ...c,
                    unit_price: c.item_value,
                    weight: c.net_weight,
                    hs_code_id: null,
                };
            });

            state.service = {
                currency: "SAR",
                price: payload.shipment_fees,
                savings: 0,
                serviceType: payload.service_name,
                provider: payload.vendor_name,
                weight: payload.total_weight,
                delivery: payload.deliver_time,
                id: 0,
            };

            state.shipment.insured = 0;
            state.shipment.reason = payload.reason;
            state.shipment.customer_reference = payload.customer_reference;
            state.shipment.user_identity = payload.user_identity;

            state.viewsForForm2 =
                payload.packages[0].type == "env" ? "env" : "box&bag";
        },
        update_account(state) {
            state.user.is_updated = false;
            state.user.mobile_verified = false;
            state.user.email_verified = false;
        },

        save_user_name(state, name) {
            state.user_name = name;
        },
        save_statistics(state, payload) {
            state.statistics = payload;
        },
        save_banks(state, payload) {
            state.banks = payload;
        },
        save_transactions(state, payload) {
            state.credit_transactions = payload;
        },
        save_total_due_amount(state, payload) {
            state.total_due_amount_invoices = payload;
        },
        saveLastPaymentOption(state, payload) {
            state.lastPaymentOption = payload;
        },
        saveLastInvoice(state, payload) {
            state.lastInvoice = payload;
        },

        // removePicked(state, type) {
        //     state.shipment[type] = {
        //         street: "",
        //         city: "",
        //         state: "",
        //         country: "",
        //         zip: "",
        //         email: "",
        //         phone: "",
        //         id: -1,
        //     };
        // },
    },

    //******************
    //* Actions
    //******************

    actions: {
        GET_TOTAL_DUE_AMOUNT_INVOICES({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                http.get(API.total_due_amount, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        commit("save_total_due_amount", res.data.data);
                        resolve("done");
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },
        CREDIT_REQUEST({ state, commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                http.post(API.request_credit, payload, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        dispatch("CREDIT_REQUEST_TRANSACTIONS", "");
                        resolve("done");
                    })
                    .catch((error) => {
                        reject(error.response.data.message);
                    });
            });
        },
        CREDIT_REQUEST_TRANSACTIONS({ commit, state }, filter) {
            return new Promise((resolve, reject) => {
                http.get(API.credit_requests + filter, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        commit("save_transactions", res.data.data);
                        resolve("done");
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },
        GET_BANKS({ commit, state }) {
            return new Promise((resolve, reject) => {
                http.get(API.banks, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        commit("save_banks", res.data.data);
                        resolve("done");
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },
        GET_STATISTICS({ commit, state }) {
            return new Promise((resolve, reject) => {
                http.get(API.getStatistics, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        commit("save_statistics", res.data.data);
                        resolve("done");
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },
        updateAccount({ state, commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                http.put(API.updateAccount, payload, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        dispatch("userData");
                        commit("update_account");
                        resolve("done");
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        UPDATE_USER_PROP({ state, commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                http.put(API.updateUserProperty, payload, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        dispatch("userData");
                        commit("update_account");
                        resolve("done");
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },

        UPLOADE_AVATAR({ state, commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                http.post(API.uploadAvatar, payload, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        dispatch("userData");
                        commit("update_account");
                        resolve("done");
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },

        RESEND_VERIFICAION_EMAIL({ state }) {
            return new Promise((resolve, reject) => {
                http.post(
                    API.resendEmailVerification,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                )
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        RESEND_VERIFICAION_CODE({ state }) {
            return new Promise((resolve, reject) => {
                http.post(
                    API.resendMobileVerification,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                )
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        CHECK_EMAIL({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                http.post(API.checkEmail, payload, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        commit("save_user_name", res.data.data);
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        ARCHIVE_SHIPMENTS({ commit, state, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                http.post(API.archiveShipments, payload, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        if (payload.is_archive) {
                            dispatch("userShipment", 0);
                        } else {
                            dispatch("userShipment", 1);
                        }
                        resolve("done");
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },
        GET_CONTENT_LIST({ commit, state }) {
            return new Promise((resolve, reject) => {
                http.get(API.saveInContentList, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        commit("save_content_list", res.data.data);
                        resolve("done");
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },
        GET_LIST({ commit, state }) {
            return new Promise((resolve, reject) => {
                http.get(API.saveInList, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        commit("save_list", res.data.data);
                        resolve("done");
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },
        SAVE_IN_Content_LIST: ({ commit, state, dispatch }, payload) => {
            return new Promise((resolve, reject) => {
                resolve("done");
                let req = {
                    title: `${payload.item.title} - ${payload.item.unit_price}${
                        payload.unit_price
                    } - ${payload.item.quantity} - ${payload.item.weight}${
                        payload.unit_system == "SI" ? "KG" : "lb"
                    }`,
                    content_title: payload.item.title,
                    quantity: payload.item.quantity,
                    unit_price: payload.item.unit_price,
                    unit_system: payload.unit_system,
                    weight: payload.item.weight,
                    currency: payload.unit_price,
                };
                http.post(API.saveInContentList, req, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        dispatch("GET_CONTENT_LIST");
                        resolve("done");
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },
        SAVE_IN_LIST: ({ commit, state, dispatch }, payload) => {
            return new Promise((resolve, reject) => {
                let req = {
                    title: `${
                        payload.type == "box" ? "parcel" : payload.type
                    } ${payload.weight}${
                        payload.measurement == "metric" ? "kg" : "lb"
                    } | ${payload.width} x ${payload.length} x ${
                        payload.height
                    } ${payload.measurement == "metric" ? "cm" : "in"}`,
                    width: payload.width,
                    length: payload.length,
                    height: payload.height,
                    weight: payload.weight,
                    unit_system: payload.measurement,
                };
                http.post(API.saveInList, req, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        dispatch("GET_LIST");
                        resolve("done");
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },
        PICKUP: ({ commit, state }, requestPayload) => {
            return new Promise((resolve, reject) => {
                http.post(API.pickupRequest, requestPayload, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                })
                    .then((res) => {
                        resolve("done");
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        GET_TRANSACTIONS: async ({ commit, state }) => {
            try {
                let r = await http.get(API.transactions, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                });
                commit("save_all_transactions", r.data.data);
                return r;
            } catch (e) {
                throw { message: "error", data: e };
            }
        },
        domestic_rate({ commit }, payload) {
            commit("domestic_rate", payload);
        },
        check_credit({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                http.post(
                    API.check_credit + payload,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                )
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },
        payWithCredit({ commit, state }, payload) {
            return new Promise((resolve, reject) => {
                http.post(
                    API.payWithCredit + payload,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                )
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },
        store_transaction({ commit, state }, query) {
            return new Promise((resolve, reject) => {
                http.post(
                    API.store_transaction,
                    {
                        transaction_id: query.id,
                        resource_path: query.resourcePath,
                        response: JSON.stringify(query),
                        order_id: state.lastShipment.order_id,
                        payment_option: state.lastPaymentOption,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                )
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error.response.data.message);
                    });
            });
        },
        invoice_store_transaction({ commit, state }, query) {
            return new Promise((resolve, reject) => {
                http.post(
                    API.invoice_store_transaction,
                    {
                        transaction_id: query.id,
                        invoice_id: state.lastInvoice,
                        payment_option: state.lastPaymentOption,
                        resource_path: query.resourcePath,
                        response: JSON.stringify(query),
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                )
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error.response.data.message);
                    });
            });
        },
        getCheckoutId({ commit, dispatch, state }, { id, payment_option }) {
            return new Promise((resolve, reject) => {
                // dispatch("shipment").then((newId) => {
                http.post(
                    API.hyperPay,
                    {
                        order_id: id,
                        payment_option: payment_option,
                        // false => mada
                        // true => visa
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                )
                    .then((res) => {
                        commit("saveLastShipment", res.data.data);
                        commit("saveLastPaymentOption", payment_option);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject("error");
                    });
                // });
            });
        },
        invoiceGetCheckoutId(
            { commit, dispatch, state },
            { id, payment_option }
        ) {
            return new Promise((resolve, reject) => {
                // dispatch("shipment").then((newId) => {
                http.post(
                    API.invoiceHyperPay,
                    {
                        invoice_id: id,
                        payment_option: payment_option,
                        // false => mada
                        // true => visa
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                )
                    .then((res) => {
                        commit("saveLastInvoice", id);
                        commit("saveLastPaymentOption", payment_option);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },
        resetForms({ commit }) {
            commit("resetPackages");
        },
        handleViewForm2({ commit }, type) {
            commit("editViewsForForm2", type);
        },
        login({ commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                http.post(API.login, {
                    email: payload.username,
                    password: payload.password,
                    remember_me: 1,
                })
                    .then((res) => {
                        payload.token = res.data.data.access_token;
                        payload.email_verified = res.data.data.email_verified;
                        payload.mobile_verified = res.data.data.mobile_verified;
                        payload.authorized = true;
                        payload.is_updated = res.data.data.is_updated;
                        payload.password = null;
                        // payload.verified = true
                        commit("saveUserData", payload);
                        dispatch("userData");
                        resolve("authorized");
                    })
                    .catch((error) => {
                        reject(error.response.data.message);
                    });
            });
        },

        logout: async ({ commit, state }) => {
            try {
                let response = await http.get(API.logout, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                });
                commit("reset");
                return { message: "logged-out", data: response };
            } catch (e) {
                throw {
                    message: "Something went wrong while logging-out.",
                    data: e,
                };
            }
        },

        resetSession: ({ commit }) => {
            commit("resetSession");
        },

        userData: async ({ commit, state }) => {
            try {
                let response = await http.get(API.user, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                });
                commit("userData", response.data.data);
                return "done";
            } catch (e) {
                throw { message: e.data.response.data, data: e };
            }
        },
        userShipment: async ({ commit, state }, filter) => {
            try {
                let response = await http.get(API.userShipment + filter, {
                    headers: {
                        Authorization: `Bearer ${state.user.token}`,
                    },
                });
                commit("userShipment", response.data.data);
                return response;
            } catch (e) {
                throw { data: e };
            }
        },
        getPage: async ({ commit, state }, payload) => {
            try {
                let response = await http.get(
                    `${API.userShipment}?page=${payload}`,
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                );
                commit("userShipment", response.data.data);
                return response;
            } catch (e) {
                throw { data: e };
            }
        },
        register({ dispatch }, payload) {
            return new Promise((resolve, reject) => {
                http.post(API.register, payload)
                    .then((res) => {
                        dispatch("login", {
                            username: payload.email,
                            password: payload.password,
                        })
                            .then((res) => {
                                resolve("done");
                            })
                            .catch((error) => {
                                reject(error);
                            });
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        verifyMobile: async ({ state, commit }, payload) => {
            return new Promise((resolve, reject) => {
                http.post(
                    API.verifyMobile,
                    {
                        verification_code: payload,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                )
                    .then((res) => {
                        commit("verify_mobile");
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error.response.data.message);
                    });
            });
        },

        verified: ({ commit }) => {
            commit("verified");
        },

        createAddress: async ({ state }, payload) => {
            try {
                let response = await http.post(
                    API.addresses,
                    {
                        full_name: payload.full_name,
                        email: "",
                        country_id: payload.country_id,
                        city: payload.city,
                        city_id: payload.city_id,
                        mobile: payload.mobile,
                        address_one: payload.address_one,
                        address_two: payload.address_two,
                        postal_code: "",
                        state: payload.state,
                        company: payload.company,
                    },
                    { headers: { Authorization: `Bearer ${state.user.token}` } }
                );
                return response;
            } catch (e) {
                throw {
                    message: "Something went wrong. Please try again later",
                    data: e,
                };
            }
        },

        address: async ({ commit, state }, payload) => {
            try {
                let endPoint =
                    payload === null
                        ? `${API.addresses}`
                        : `${API.addresses}?pagination=true&page=${payload}`;
                let r = await http.get(endPoint, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                });
                commit("address", r.data.data);
                return r;
            } catch (e) {
                throw { data: e };
            }
        },

        async deleteAddress({ commit, state }, payload) {
            try {
                let r = await http.delete(`${API.addresses}/${payload}`, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                });
                return r;
            } catch (e) {
                throw { data: e };
            }
        },

        async editAddress({ commit, state }, payload) {
            try {
                let r = await http.put(
                    `${API.addresses}/${payload.id}`,
                    {
                        full_name: payload.full_name,
                        email: payload.email,
                        country_id: payload.country_id,
                        city: payload.city,
                        city_id: payload.city_id,
                        mobile: payload.mobile,
                        address_one: payload.address_one,
                        address_two: payload.address_two,
                        postal_code: payload.postal_code,
                        state: payload.state,
                        company: payload.company,
                    },
                    { headers: { Authorization: `Bearer ${state.user.token}` } }
                );
                return r;
            } catch (e) {
                throw { data: e };
            }
        },

        removePicked({ commit, state }, type) {
            commit("removePicked", type);
        },

        countries: async ({ commit, state }) => {
            try {
                let r = await http.get(API.countries, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                });
                commit("countries", r.data.data);
                return r;
            } catch (e) {
                throw { message: "error", data: e };
            }
        },

        rate: async ({ commit, state }, payload) => {
            state.rate = [];
            let total_weight = state.shipment.total_weight;
            let packageSet = [];
            let types = { envelope: 1, box: 2, bag: 3, parcel: 2, Parcel: 2 };
            payload.forEach((p) => {
                packageSet.push({
                    weight: parseFloat(Number(p.weight).toFixed(2)),
                    height: parseFloat(Number(p.height).toFixed(2)),
                    width: parseFloat(Number(p.width).toFixed(2)),
                    length: parseFloat(Number(p.length).toFixed(2)),
                    quantity: parseFloat(Number(Number(p.quantity).toFixed(2))),
                    total_weight: parseFloat(
                        Number(Number(p.total_weight).toFixed(2))
                    ),
                    unit_system: p.measurement == "metric" ? "SI" : "SU",
                    type: types[`${p.type}`],
                });
            });
            try {
                let r = await http.post(
                    API.rates,
                    {
                        packages: packageSet,
                        weight: total_weight,
                        addresses: {
                            origin: state.shipment.sendFrom.id,
                            destination: state.shipment.sendTo.id,
                        },
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                );
                commit("packageSet", packageSet);
                commit("packages", payload);
                commit("rate", r.data.data);

                return { status: true, data: r };
            } catch (e) {
                throw { status: false, data: e };
            }
        },

        finalWeight: ({ commit }, payload) => {
            commit("finalWeight", payload);
        },

        UPDATE_SHIPMENT: ({ state }) => {
            return new Promise((resolve, reject) => {
                http.put(
                    API.editshipment,
                    {
                        shipment_id: state.shipment.shipment_id,
                        packages: state.shipment.packageSet,
                        contents: state.contents,
                        insured: 0,
                        reason: state.shipment.reason,
                        customer_reference: state.shipment.customer_reference,
                        user_identity: state.shipment.user_identity,
                        weight: state.shipment.total_weight,
                        addresses: {
                            origin: state.shipment.sendFrom.id,
                            destination: state.shipment.sendTo.id,
                        },
                        currency: "SAR",
                        unit_system: "SI",
                        service: state.filterdService,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                )
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },
        primary_address: ({ state, dispatch }, { id, status }) => {
            return new Promise((resolve, reject) => {
                http.put(
                    API.primary_address,
                    {
                        id: id,
                        is_basic: status,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                )
                    .then((res) => {
                        dispatch("address", null);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },

        shipment: ({ state }) => {
            return new Promise((resolve, reject) => {
                let overweightFee = state.shipment.packages.reduce((a, b) => {
                    if (
                        (b.measurement == "metric" && b.weight > 65) ||
                        (b.measurement == "imperial" && b.weight > 143)
                    ) {
                        a += 350 * b.quantity;
                    }
                    return a;
                }, 0);
                let oversizeFee = state.shipment.packages.reduce((a, b) => {
                    if (
                        (b.measurement == "metric" &&
                            (b.length > 104 ||
                                b.width > 104 ||
                                b.height > 104)) ||
                        (b.measurement == "imperial" &&
                            (b.length > 41 || b.width > 41 || b.height > 41))
                    ) {
                        a += 350 * b.quantity;
                    }
                    return a;
                }, 0);
                http.post(
                    API.shipment,
                    {
                        packages: state.shipment.packageSet,
                        contents: state.contents,
                        insured: 0,
                        reason: state.shipment.reason,
                        customer_reference: state.shipment.customer_reference,
                        user_identity: state.shipment.user_identity,
                        weight: state.shipment.total_weight,
                        addresses: {
                            origin: state.shipment.sendFrom.id,
                            destination: state.shipment.sendTo.id,
                        },
                        currency: "SAR",
                        unit_system: "SI",
                        service: state.filterdService,
                        oversize_fees: oversizeFee,
                        overweight_fees: overweightFee,
                        tax_fees: 0,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                )
                    .then((res) => {
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject("error");
                    });
            });
        },

        sendTo: ({ commit, state }, payload) => {
            if (payload.id != state.shipment.sendTo.id) {
                commit("sendTo", payload);
            } else {
                commit("sendTo", {
                    street: "",
                    city: "",
                    state: "",
                    country: "",
                    zip: "",
                    email: "",
                    phone: "",
                    id: -1,
                });
            }
        },
        sendFrom: ({ commit, state }, payload) => {
            if (payload.id != state.shipment.sendFrom.id) {
                commit("sendFrom", payload);
            } else {
                commit("sendFrom", {
                    street: "",
                    city: "",
                    state: "",
                    country: "",
                    zip: "",
                    email: "",
                    phone: "",
                    id: -1,
                });
            }
        },

        setPackageUnit: ({ commit }, payload) => {
            commit("setPackageUnit", payload);
        },

        addShipment: ({ commit }, payload) => {
            commit("addShipment", payload);
        },
        addShipmentItem: ({ commit }, payload) => {
            commit("addShipmentItem", payload);
        },
        deleteShipment: ({ commit }, payload) => {
            commit("deleteShipment", payload);
        },
        editQuantity: ({ commit }, payload) => {
            commit("editQuantity", payload);
        },
        editWeight: ({ commit }, payload) => {
            commit("editWeight", payload);
        },
        editLength: ({ commit }, payload) => {
            commit("editLength", payload);
        },
        editWidth: ({ commit }, payload) => {
            commit("editWidth", payload);
        },
        editHeight: ({ commit }, payload) => {
            commit("editHeight", payload);
        },
        editTotalWeight: ({ commit }, payload) => {
            commit("editTotalWeight", payload);
        },
        service: ({ commit }, payload) => {
            commit("service", payload);
        },
        addItems: ({ commit }, payload) => {
            commit("addItems", payload);
        },
        eraseItems: ({ commit }, payload) => {
            commit("eraseItems", payload);
        },
        insured: ({ commit }, payload) => {
            commit("insured", payload);
        },
        init1: ({ commit }) => {
            commit("init1");
        },
        init2: ({ commit }) => {
            commit("init2");
        },
        contents: ({ commit }, payload) => {
            commit("contents", payload);
        },
        SAVE_FEES: ({ commit }, payload) => {
            commit("save_fees", payload);
        },
        REASON: ({ commit }, payload) => {
            commit("reason", payload);
        },
        CUSTOMER_REFERENCE: ({ commit }, payload) => {
            commit("customer_reference", payload);
        },
        USER_IDENTITY: ({ commit }, payload) => {
            commit("user_identity", payload);
        },
        async citiesHandlers({ commit, state }, payload) {
            try {
                let response = await http.get(
                    `${API.getCitiesSearch}?country_id=${payload.country}${
                        payload.keyword ? `&city_name=${payload.keyword}` : ""
                    }${payload.state ? `&state_id=${payload.state}` : ""}`,
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                );

                let newResData = response.data.data;

                for (let obj in newResData) {
                    newResData[obj]["city_id"] = `${newResData[obj].id}`;
                    newResData[obj]["id"] = obj;
                    newResData[obj][
                        "name"
                    ] = `${newResData[obj]["city_name"]} - ${newResData[obj]["city_name_ar"]}`;
                    newResData[obj]["postalCode"] =
                        newResData[obj]["post_code"];

                    delete newResData[obj]["post_code"];
                    delete newResData[obj]["city_name"];
                }
                commit("citiesSearchResults", _.uniqBy(newResData, "name"));
                commit("postalCodeListResults", newResData);
            } catch (e) {
                document.querySelector(".dropdown-content").style.opacity = "0";
                throw { message: e.data.response.data, data: e };
            }
        },
        async statesHandlers({ commit, state }, payload) {
            try {
                let response = await http.get(
                    `${API.getStateSearch}?country_id=${payload}`,
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                );

                let newResData = response.data.data;

                for (let obj in newResData) {
                    newResData[obj][
                        "name"
                    ] = `${newResData[obj]["state_name"]}`;

                    delete newResData[obj]["state_name"];
                }
                commit("statesSearchResult", newResData);
            } catch (e) {
                document.querySelector(".dropdown-content").style.opacity = "0";
                throw { message: e.data.response.data, data: e };
            }
        },
        async orderDetails({ commit, state }, payload) {
            commit("currentOrderDetails", null);
            try {
                let response = await http(`${API.orderDetails}/${payload}`, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                });
                commit("currentOrderDetails", response.data.data);
                return response.data.data;
            } catch (e) {
                throw { message: e.data.response.data, data: e };
            }
        },
        restoreShipment({ commit, state }, { id, copyShipment }) {
            return new Promise((resolve, reject) => {
                http(`${API.orderDetails}/${id}`, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                }).then((response) => {
                    if (copyShipment) response.data.data.id = null;
                    commit("restore_shipment", response.data.data);
                    resolve("good");
                });
            });
        },
        async postalCodeHandlers({ commit, state }, payload) {
            try {
                await http.get(
                    `${API.postCode}?post_code=${payload.keyword.replace(
                        /^0+(?=\d)/,
                        ""
                    )}`,
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                );

                let response = await http.get(
                    `${API.getCitiesSearch}?country_id=${payload.country}${
                        payload.keyword ? `&city_name=${payload.keyword}` : ""
                    }${payload.state ? `&state_id=${payload.state}` : ""}`,
                    {
                        headers: {
                            Authorization: `Bearer ${state.user.token}`,
                        },
                    }
                );

                let newResData = response.data.data;

                for (let obj in newResData) {
                    newResData[obj]["id"] = obj;
                    newResData[obj]["name"] = `${newResData[obj]["post_code"]}`;
                    newResData[obj]["postalCode"] =
                        newResData[obj]["post_code"];

                    delete newResData[obj]["post_code"];
                    delete newResData[obj]["city_name"];
                }

                commit(
                    "postCodeSearchResultByKeyword",
                    _.uniqBy(newResData, "name")
                );
                commit("postCodeSearchResult", false);
            } catch (e) {
                commit("postCodeSearchResult", true);
                throw { message: e.data.response.data, data: e };
            }
        },

        async internationalRateReq({ state }, payload) {
            try {
                let response = await http.post(API.internationalRate, payload, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                });
                return response;
            } catch (e) {
                throw {
                    message: "Something went wrong. Please try again later",
                    data: e,
                };
            }
        },

        async domesticRateReq({ state }, payload) {
            try {
                let response = await http.post(API.domesticRate, payload, {
                    headers: { Authorization: `Bearer ${state.user.token}` },
                });
                return response;
            } catch (e) {
                throw {
                    message: "Something went wrong. Please try again later",
                    data: e,
                };
            }
        },

        forgetPassword: async ({ state }, payload) => {
            try {
                let response = await http.post(API.forgetPassword, payload);
                return response;
            } catch (e) {
                throw {
                    message: "Something went wrong. Please try again later",
                    data: e,
                };
            }
        },

        resetPassword: async ({ state }, payload) => {
            try {
                let response = await http.post(API.resetPassword, payload);
                return response;
            } catch (e) {
                throw {
                    message: "Something went wrong. Please try again later",
                    data: e,
                };
            }
        },

        verifyEmail: async ({ state, commit }, payload) => {
            try {
                let response = await http.get(payload, {
                    headers: {
                        Authorization: `Bearer ${state.user.token}`,
                    },
                });
                commit("updateEmailVerification");
                return response;
            } catch (e) {
                throw {
                    message: "Something went wrong. Please try again later",
                    data: e,
                };
            }
        },

        slack({ state }, error) {
            http.post(
                "https://hooks.slack.com/services/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",
                {
                    text: error.name,
                    attachments: [
                        {
                            author_name: window.location.href,
                            color: "danger",
                            title: error.err.toString(),
                            text: error.err.stack,
                        },
                    ],
                }
            );
        },
    },
});
